import React, { useContext } from 'react';
import RoomContext from '../RoomContext';
import DeviceStatus from './DeviceStatus';

// Header for a room view: shows which tenant/room is open, a device online/offline indicator, and,
// unless the tenant has only one room, a link back to the tenant's room picker.
const StatusBar = () => {
  const { tenant, room, singleRoom } = useContext(RoomContext);
  return (
    <div className="d-flex align-items-center justify-content-between py-2">
      <span className="fw-semibold text-capitalize">{room}</span>
      <div className="d-flex align-items-center gap-3">
        {!singleRoom && <a href={`/${tenant}`} className="small text-decoration-none">Cambiar sala</a>}
        <DeviceStatus />
      </div>
    </div>
  );
};

export default StatusBar;
